module.exports = __webpack_public_path__ + "media/images/icons/ihra-facebook_share-8093913da4c509116e95e398d046b62a.svg";